import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    selectAllTravelZone,
    selectTravelZoneEntities, selectTravelZoneFetched, selectTravelZoneLatestUpdatedAt,
    TRAVEL_ZONE_KEY,
    TravelZoneState,
} from '../reducers/travel-zone.reducer';


const selectState = createFeatureSelector<TravelZoneState>(TRAVEL_ZONE_KEY);

export const getTravelZoneDictionary = createSelector(selectState, selectTravelZoneEntities);
export const getTravelZones = createSelector(selectState, selectAllTravelZone);
export const getTravelZonesActive = createSelector(getTravelZones, e => e.filter(v => !v.DeletedAt));
export const getTravelZonesFetched = createSelector(selectState, selectTravelZoneFetched);
export const getTravelZoneLatestUpdatedAt = createSelector(selectState, selectTravelZoneLatestUpdatedAt);

export const getTravelZoneById = (props: { id: number }) => createSelector(getTravelZoneDictionary, (dictionary) => props?.id && dictionary[props.id]);
